import { Injectable } from "@angular/core";
import { IntegratedAdmissionWizardService } from "./integrated-admission-wizard.service";
import { IntegratedAdmissionAppointment } from "src/app/model/integrated-admission/integrated-admission-appointment";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { IntegratedAdmissionService } from "src/app/services/integrated-admission/integrated-admission.service";
import { NotificationToastService } from "src/app/services/notification-toast.service";
import { OnLineValidationService } from "src/app/services/on-line-validation/on-line-validation.service";
import { PracticeService } from "src/app/services/practice.service";
import { ValorizationService } from "src/app/services/valorization/valorization.service";
import { IntegratedAdmissionAppointmentPlan } from "src/app/model/integrated-admission/integrated-admission-appointment-plan";
import { InvoiceCashDeskService } from "src/app/services/invoice-cash-desk/invoice-cash-desk.service";
import { ConfirmDialogService } from "src/app/services/confirm-dialog.service";
import { BudgetService } from "src/app/services/budget/budget.service";
import { MatDialog } from "@angular/material";
import { BudgetFilter } from "src/app/model/budget/budget-filter";
import { BudgetListDialogComponent } from "../../dialogs/budget-list-dialog/budget-list-dialog.component";
import { Observable } from "rxjs";
import { NormativeService } from "src/app/services/normative/normative.service";
import { ReservationService } from "src/app/services/reservation.service";
import { AdmissionGroupedProcedureRegionService } from "src/app/services/admission-grouped-procedure-region/admission-grouped-procedure-region.service";
import { PatientService } from "src/app/services/patient.service";
import { LaboratoryAppointmentQuestionService } from "src/app/services/laboratory-appointment-question/laboratory-appointment-question.service";
import { CampaniaEncuestaService } from "src/app/services/campania-encuesta/campania-encuesta.service";
import { TurnoCampaniaEncuestaRespuestaService } from "src/app/services/campania-encuesta/turno-campania-encuesta-respuesta.service";
import { ServerTimeService } from "src/app/services/server-time.service";

@Injectable({
  providedIn: "root",
})
export class IntegratedAdmissionRegularWizardService extends IntegratedAdmissionWizardService {
  constructor(
    private activatedRoute: ActivatedRoute,
    public patientService: PatientService,
    public authService: AuthService,
    public router: Router,
    public notificationToastService: NotificationToastService,
    public onLineValidationService: OnLineValidationService,
    public integratedAdmissionService: IntegratedAdmissionService,
    public valorizationService: ValorizationService,
    public practiceService: PracticeService,
    public invoiceIntegratedAdmissionCashDeskService: InvoiceCashDeskService,
    public confirmDialogService: ConfirmDialogService,
    public budgetService: BudgetService,
    public campaniaEncuestaService: CampaniaEncuestaService,
    public turnoCampaniaEncuestaRespuestaService: TurnoCampaniaEncuestaRespuestaService,
    public dialog: MatDialog,
    public normativeService: NormativeService,
    public reservationService: ReservationService,
    public laboratoryAppointmentQuestionService: LaboratoryAppointmentQuestionService,
    public admissionGroupedProcedureRegionService: AdmissionGroupedProcedureRegionService,
    public serverTimeService: ServerTimeService,
  ) {
    super(
      authService,
      patientService,
      router,
      notificationToastService,
      onLineValidationService,
      integratedAdmissionService,
      valorizationService,
      practiceService,
      invoiceIntegratedAdmissionCashDeskService,
      confirmDialogService,
      budgetService,
      campaniaEncuestaService,
      turnoCampaniaEncuestaRespuestaService,
      dialog,
      normativeService,
      reservationService,
      laboratoryAppointmentQuestionService,
      admissionGroupedProcedureRegionService,
      serverTimeService,
    );
  }

  canRefreshPracticeToParticular(): boolean {
    return false;
  }

  getConfirmDialog(): Observable<boolean> {
    return this.confirmDialogService.confirm(
      "Admisión",
      "¿Esta seguro que desea finalizar la admisión?",
      "Finalizar",
      "Cancelar",
      false,
      true,
      true,
    );
  }

  validateProceduresForValidationLoaded(): boolean {
    return true;
  }

  showPreAdmissionPatientAppointment(): boolean {
    return false;
  }

  async finish() {
    await this.create();
  }

  canExtractProcedures(): boolean {
    return false;
  }

  showAddAppointment(): boolean {
    return true;
  }

  showCopyAppointment(): boolean {
    return true;
  }

  showPrint(): boolean {
    return false;
  }

  cancel(): void {
    if (this.existsValidateedAppointmet()) {
      this.notificationToastService.info(
        "EXISTEN PRÁCTICAS REGISTRADAS QUE NO TIENEN VALIDACIÓN, ANULE ANTES DE SALIR",
        "Admisión",
      );
    } else {
      this.router.navigate(["integrated-reception-admission"]);
    }
  }

  linkAppointmentWait(): boolean {
    return false;
  }

  getReturnUrl(): string {
    return "integrated-reception-admission";
  }

  async getNewRegularAdmission(): Promise<IntegratedAdmissionAppointment[]> {
    const appointmentId = +this.activatedRoute.snapshot.paramMap.get(
      "MedicalAppointmentId",
    );

    const patientId = +this.activatedRoute.snapshot.paramMap.get("PatientId");

    const budgets = await this.budgetService.getByPatientId(patientId);
    let budgetId;

    if (budgets.length > 0) {
      budgetId = await this.getBudgetId(patientId);
    }

    const appointments =
      await this.integratedAdmissionService.getNewRegularAdmission(
        this.sectorId,
        appointmentId,
        budgetId,
      );

    appointments.forEach((appointment) => {
      appointment.BudgetId = budgetId;
      this.patientId = appointment.PatientId;
    });

    return appointments;
  }

  private async getBudgetId(patientId: number) {
    let budgetId: number;

    const dialogRef = this.dialog.open(BudgetListDialogComponent, {
      width: "80%",
      data: patientId,
    });

    const budget = await dialogRef.afterClosed().toPromise();

    if (budget) {
      budgetId = budget.Id;
    }

    return budgetId;
  }

  async getInitAdmission(): Promise<IntegratedAdmissionAppointment[]> {
    return await this.getNewRegularAdmission();
  }

  async getNewAdmission(): Promise<IntegratedAdmissionAppointment> {
    const appointment = await this.integratedAdmissionService.getNewAdmission(
      this.sectorId,
      false,
    );

    appointment.Plan = new IntegratedAdmissionAppointmentPlan();
    appointment.PatientId = this.patientId;

    return appointment;
  }

  isIntegradaPrevia(): boolean { return false; }
  isIntegradaSinTurno(): boolean { return false; }
  isIntegradaConTurno(): boolean { return true; }
}
